// 'use client';

// import {
//   Box,
//   Flex,
//   Table,
//   Tbody,
//   Td,
//   Text,
//   Th,
//   Thead,
//   Tr,
//   useColorModeValue,
//   Button,
//   HStack,
//   Input,
//   InputGroup,
//   InputLeftElement,
//   Icon,
//   Spinner,
//   Avatar,
// } from '@chakra-ui/react';

// import {
//   createColumnHelper,
//   flexRender,
//   getCoreRowModel,
//   getSortedRowModel,
//   useReactTable,
// } from '@tanstack/react-table';

// import Card from 'components/card/Card';
// import React, { useState, useMemo, useEffect } from 'react';
// import { ArrowUpIcon, ArrowDownIcon, SearchIcon } from '@chakra-ui/icons';
// import axios from 'axios';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const columnHelper = createColumnHelper();

// export default function RatingReviews() {
//   const [sorting, setSorting] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchQuery, setSearchQuery] = useState('');

//   const itemsPerPage = 10;

//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
//   const headerBg = useColorModeValue('gray.100', 'gray.700');
//   const hoverBg = useColorModeValue('gray.50', 'gray.600');

//   const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');
//   const token = localStorage.getItem('token');

//   // ───────────────────────── FETCH RATINGS ─────────────────────────
//   const fetchRatings = async () => {
//     if (!token) {
//       toast.error('Session expired. Please login again.');
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await axios.get(
//         `${baseUrl}/api/admin/audio-ratings`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (res.data.success) {
//         setData(res.data.data || []);
//         setFilteredData(res.data.data || []);
//       }
//     } catch (err) {
//       console.log(err);
//       toast.error('Failed to fetch ratings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRatings();
//   }, []);

//   // ───────────────────────── SEARCH ─────────────────────────
//   const handleSearch = (val) => {
//     setSearchQuery(val);
//     setCurrentPage(1);

//     const filtered = data.filter((r) =>
//       r.user?.name?.toLowerCase().includes(val.toLowerCase()) ||
//       r.storyTitle?.toLowerCase().includes(val.toLowerCase()) ||
//       r.chapterTitle?.toLowerCase().includes(val.toLowerCase())
//     );

//     setFilteredData(filtered);
//   };

//   // ───────────────────────── PAGINATION ─────────────────────────
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const goToPage = (page) => {
//     if (!page || page === '...') return;
//     setCurrentPage(page);
//   };

//   // ───────────────────────── COLUMNS ─────────────────────────
//   const columns = useMemo(
//     () => [
//       columnHelper.display({
//         id: 'sno',
//         header: () => <Text textAlign="center">S.No</Text>,
//         cell: ({ row }) => (
//           <Text textAlign="center">{row.index + 1}</Text>
//         ),
//       }),

//       columnHelper.accessor('user', {
//         header: () => <Text textAlign="center">User</Text>,
//         cell: (info) => (
//           <Flex justify="center" align="center" gap={2}>
//             <Avatar
//               size="sm"
//               src={
//                 info.getValue()?.profileImage
//                   ? `${baseUrl}${info.getValue().profileImage}`
//                   : ''
//               }
//               name={info.getValue()?.name}
//             />
//             <Text fontSize="sm">{info.getValue()?.name || '—'}</Text>
//           </Flex>
//         ),
//       }),

//       columnHelper.accessor('storyTitle', {
//         header: () => <Text textAlign="center">Story</Text>,
//         cell: (info) => (
//           <Text textAlign="center">{info.getValue() || '—'}</Text>
//         ),
//       }),

//       columnHelper.accessor('chapterTitle', {
//         header: () => <Text textAlign="center">Chapter</Text>,
//         cell: (info) => (
//           <Text textAlign="center">{info.getValue() || '—'}</Text>
//         ),
//       }),

//       columnHelper.accessor('rating', {
//         header: () => <Text textAlign="center">Rating</Text>,
//         cell: (info) => (
//           <Text
//             textAlign="center"
//             fontWeight="700"
//             color="orange.400"
//           >
//             ⭐ {info.getValue()}
//           </Text>
//         ),
//       }),

//       columnHelper.accessor('createdAt', {
//         header: () => <Text textAlign="center">Date</Text>,
//         cell: (info) => (
//           <Text textAlign="center" fontSize="sm">
//             {new Date(info.getValue()).toLocaleString()}
//           </Text>
//         ),
//       }),
//     ],
//     [baseUrl]
//   );

//   const table = useReactTable({
//     data: paginatedData,
//     columns,
//     state: { sorting },
//     onSortingChange: setSorting,
//     getCoreRowModel: getCoreRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//   });

//   // ───────────────────────── UI ─────────────────────────
//   return (
//     <>
//       <Card
//         w="100%"
//         p="20px"
//         bg={useColorModeValue('white', 'gray.800')}
//       >
//         {/* HEADER */}
//         <Flex
//           mb="20px"
//           justify="space-between"
//           align="center"
//           direction={{ base: 'column', md: 'row' }}
//           gap={3}
//         >
//           <Text fontSize="2xl" fontWeight="700" color={textColor}>
//             Rating & Reviews
//           </Text>

//           <InputGroup maxW="300px">
//             <InputLeftElement>
//               <Icon as={SearchIcon} color="gray.400" />
//             </InputLeftElement>
//             <Input
//               placeholder="Search user/story/chapter"
//               value={searchQuery}
//               onChange={(e) => handleSearch(e.target.value)}
//             />
//           </InputGroup>
//         </Flex>

//         {/* TABLE */}
//         {loading ? (
//           <Flex justify="center" py="50px">
//             <Spinner size="xl" />
//           </Flex>
//         ) : (
//           <Box overflowX="auto">
//             <Table minW="900px">
//               <Thead bg={headerBg}>
//                 {table.getHeaderGroups().map((hg) => (
//                   <Tr key={hg.id}>
//                     {hg.headers.map((h) => (
//                       <Th
//                         key={h.id}
//                         textAlign="center"
//                         cursor="pointer"
//                         onClick={h.column.getToggleSortingHandler()}
//                       >
//                         <Flex justify="center">
//                           {flexRender(
//                             h.column.columnDef.header,
//                             h.getContext()
//                           )}
//                           {h.column.getIsSorted() === 'asc' ? (
//                             <ArrowUpIcon ml={2} />
//                           ) : h.column.getIsSorted() === 'desc' ? (
//                             <ArrowDownIcon ml={2} />
//                           ) : null}
//                         </Flex>
//                       </Th>
//                     ))}
//                   </Tr>
//                 ))}
//               </Thead>

//               <Tbody>
//                 {table.getRowModel().rows.map((row) => (
//                   <Tr key={row.id} _hover={{ bg: hoverBg }}>
//                     {row.getVisibleCells().map((cell) => (
//                       <Td key={cell.id} textAlign="center">
//                         {flexRender(
//                           cell.column.columnDef.cell,
//                           cell.getContext()
//                         )}
//                       </Td>
//                     ))}
//                   </Tr>
//                 ))}
//               </Tbody>
//             </Table>
//           </Box>
//         )}

//         {/* PAGINATION */}
//         <Flex justify="space-between" mt={5}>
//           <Text fontSize="sm">
//             Page {currentPage} of {totalPages}
//           </Text>

//           <HStack>
//             <Button
//               size="sm"
//               onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//             >
//               Prev
//             </Button>
//             <Button
//               size="sm"
//               onClick={() =>
//                 setCurrentPage((p) => Math.min(p + 1, totalPages))
//               }
//             >
//               Next
//             </Button>
//           </HStack>
//         </Flex>
//       </Card>

//       <ToastContainer />
//     </>
//   );
// }

'use client';

import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Icon,
  Spinner,
  Avatar,
} from '@chakra-ui/react';

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

import Card from 'components/card/Card';
import React, { useState, useMemo, useEffect } from 'react';
import { ArrowUpIcon, ArrowDownIcon, SearchIcon } from '@chakra-ui/icons';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const columnHelper = createColumnHelper();

export default function RatingReviews() {
  const [sorting, setSorting] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const itemsPerPage = 10;

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const headerBg = useColorModeValue('gray.100', 'gray.700');
  const hoverBg = useColorModeValue('gray.50', 'gray.600');

  const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');
  const token = localStorage.getItem('token');

  // ───────────────────────── FETCH RATINGS ─────────────────────────
  const fetchRatings = async () => {
    if (!token) {
      toast.error('Session expired. Please login again.');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(`${baseUrl}/api/admin/audio-ratings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        setData(res.data.data || []);
        setFilteredData(res.data.data || []);
      }
    } catch (err) {
      console.log(err);
      toast.error('Failed to fetch ratings');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (ratingId) => {
    if (!window.confirm('Are you sure you want to delete this rating?')) return;

    try {
      await axios.delete(`${baseUrl}/api/admin/audio-ratings/${ratingId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success('Rating deleted successfully');

      // ✅ refresh list
      fetchRatings();
    } catch (err) {
      console.log(err);
      toast.error('Failed to delete rating');
    }
  };

  useEffect(() => {
    fetchRatings();
  }, []);

  // ───────────────────────── SEARCH ─────────────────────────
  const handleSearch = (val) => {
    setSearchQuery(val);
    setCurrentPage(1);

    const filtered = data.filter(
      (r) =>
        r.user?.name?.toLowerCase().includes(val.toLowerCase()) ||
        r.storyTitle?.toLowerCase().includes(val.toLowerCase()) ||
        r.chapterTitle?.toLowerCase().includes(val.toLowerCase()),
    );

    setFilteredData(filtered);
  };

  // ───────────────────────── PAGINATION ─────────────────────────
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const goToPage = (page) => {
    if (!page || page === '...') return;
    setCurrentPage(page);
  };

  // ───────────────────────── COLUMNS ─────────────────────────
  const columns = useMemo(
    () => [
      columnHelper.display({
        id: 'sno',
        header: () => <Text textAlign="center">S.No</Text>,
        cell: ({ row }) => <Text textAlign="center">{row.index + 1}</Text>,
      }),

      columnHelper.accessor('user', {
        header: () => <Text textAlign="center">User</Text>,
        cell: (info) => (
          <Flex justify="center" align="center" gap={2}>
            <Avatar
              size="sm"
              src={
                info.getValue()?.profileImage
                  ? `${baseUrl}${info.getValue().profileImage}`
                  : ''
              }
              name={info.getValue()?.name}
            />
            <Text fontSize="sm">{info.getValue()?.name || '—'}</Text>
          </Flex>
        ),
      }),

      columnHelper.accessor('storyTitle', {
        header: () => <Text textAlign="center">Story</Text>,
        cell: (info) => (
          <Text textAlign="center">{info.getValue() || '—'}</Text>
        ),
      }),

      columnHelper.accessor('chapterTitle', {
        header: () => <Text textAlign="center">Chapter</Text>,
        cell: (info) => (
          <Text textAlign="center">{info.getValue() || '—'}</Text>
        ),
      }),

      columnHelper.accessor('rating', {
        header: () => <Text textAlign="center">Rating</Text>,
        cell: (info) => (
          <Text textAlign="center" fontWeight="700" color="orange.400">
            ⭐ {info.getValue()}
          </Text>
        ),
      }),

      columnHelper.accessor('createdAt', {
        header: () => <Text textAlign="center">Date</Text>,
        cell: (info) => (
          <Text textAlign="center" fontSize="sm">
            {new Date(info.getValue()).toLocaleString()}
          </Text>
        ),
      }),

         columnHelper.display({
      id: 'actions',
      header: () => <Text textAlign="center">Action</Text>,
      cell: ({ row }) => (
        <Flex justify="center">
          <Button
            size="sm"
            colorScheme="red"
            onClick={() => handleDelete(row.original.id)}
          >
            Delete
          </Button>
        </Flex>
      ),
    }),
    ],



    [baseUrl],
  );

  const table = useReactTable({
    data: paginatedData,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  // ───────────────────────── UI ─────────────────────────
  return (
    <>
      <Card w="100%" p="20px" bg={useColorModeValue('white', 'gray.800')}>
        {/* HEADER */}
        <Flex
          mb="20px"
          justify="space-between"
          align="center"
          direction={{ base: 'column', md: 'row' }}
          gap={3}
        >
          <Text fontSize="2xl" fontWeight="700" color={textColor}>
            Rating & Reviews
          </Text>

          <InputGroup maxW="300px">
            <InputLeftElement>
              <Icon as={SearchIcon} color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Search user/story/chapter"
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </InputGroup>
        </Flex>

        {/* TABLE */}
        {loading ? (
          <Flex justify="center" py="50px">
            <Spinner size="xl" />
          </Flex>
        ) : (
          <Box overflowX="auto">
            <Table minW="900px">
              <Thead bg={headerBg}>
                {table.getHeaderGroups().map((hg) => (
                  <Tr key={hg.id}>
                    {hg.headers.map((h) => (
                      <Th
                        key={h.id}
                        textAlign="center"
                        cursor="pointer"
                        onClick={h.column.getToggleSortingHandler()}
                      >
                        <Flex justify="center">
                          {flexRender(
                            h.column.columnDef.header,
                            h.getContext(),
                          )}
                          {h.column.getIsSorted() === 'asc' ? (
                            <ArrowUpIcon ml={2} />
                          ) : h.column.getIsSorted() === 'desc' ? (
                            <ArrowDownIcon ml={2} />
                          ) : null}
                        </Flex>
                      </Th>
                    ))}
                  </Tr>
                ))}
              </Thead>

              <Tbody>
                {table.getRowModel().rows.map((row) => (
                  <Tr key={row.id} _hover={{ bg: hoverBg }}>
                    {row.getVisibleCells().map((cell) => (
                      <Td key={cell.id} textAlign="center">
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext(),
                        )}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        )}

        {/* PAGINATION */}
        <Flex justify="space-between" mt={5}>
          <Text fontSize="sm">
            Page {currentPage} of {totalPages}
          </Text>

          <HStack>
            <Button
              size="sm"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            >
              Prev
            </Button>
            <Button
              size="sm"
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            >
              Next
            </Button>
          </HStack>
        </Flex>
      </Card>

      <ToastContainer />
    </>
  );
}
